'use strict';

var React = require('react');
var ReactDOM = require('react-dom');

var Modal = require('../plugins/modal');

var isNode = typeof document === 'undefined';
if (!isNode) {
    require('./dialog.scss');
}

/*
var ContinueDialog = React.createClass({
    getInitialState: function() {
        return {
            item: null,
        };
    },
    open: function(item) {
        this.setState({
            item: item,
        }, function() {
            this.refs.modal.open();
        });
    },
    close: function() {
        this.refs.modal.close();
    },
    render: function() {
        if (!this.state.item) {
            return <div />;
        }
        var type = this.props.type == 'dyo' ? 'CONCEPT' : 'ITEM';
        return (
            <Modal width={600} height={422} ref='modal' showClose={false}>
                <div className='global-continue'>
                    <h1>{type} ADDED TO QUOTE</h1>
                    <div className='global-continue-headings'>
                        <span className='global-continue-cell'>
                            PROJECT {type}
                        </span>
                        <span className='global-continue-cell'>
                            {type} ID
                        </span>
                    </div>
                    <div className='global-continue-info'>
                        <span className='global-continue-cell'>
                            <img src={Constants.media + this.state.item.image} />
                        </span>
                        <span className='global-continue-cell'>
                            {this.state.item.name ? this.state.item.name : this.state.item.id}
                        </span>
                    </div>
                    <div className='global-continue-footer'>
                        <span className='global-continue-cell sp-button' onClick={this.close}>
                            CONTINUE BROWSING
                        </span>
                        <a className='global-continue-cell sp-button sp-default-button' href='/your-project'>
                            VIEW QUOTE REQUEST &#x25ba;
                        </a>
                    </div>
                </div>
            </Modal>
        );
    }
});
*/

// ------------------------------------------------------------------------------

var SimpleDialog = React.createClass({
    open: function(message) {
        this.refs.modal.open();
    },
    close: function() {
        this.refs.modal.close();
    },
    render: function() {
        return (
            <Modal width={600} height={600} ref='modal'>
                <div className='global-dialog'>
                    <h1 dangerouslySetInnerHTML={{ __html: this.props.title}} />
                    <div className='global-dialog-body' dangerouslySetInnerHTML={{ __html: this.props.body }} />
                </div>
            </Modal>
        );
    }
});

module.exports = SimpleDialog;



// WEBPACK FOOTER //
// ./src/components/dialog.jsx